module.exports = __webpack_public_path__ + "img/facebook.84099c98.svg";